import * as yup from "yup";
import { format, isBefore, isEqual } from "date-fns";

export const schemaAgregarIncidencia = yup
  .object({
    observacion: yup.string().required("Observación requerida").max(255, "Máximo 255 caracteres"),
    fecha_incidencia: yup
      .string()
      .test(
        "mayor_que_hoy",
        "La fecha de incidencia no puede ser mayor que hoy",
        (value, context) => {
          if (!value) {
            return true;
          }
          return (
            isBefore(format(value, "yyyy-MM-dd HH:mm"), format(new Date(), "yyyy-MM-dd HH:mm")) ||
            isEqual(format(value, "yyyy-MM-dd HH:mm"), format(new Date(), "yyyy-MM-dd HH:mm"))
          );
        }
      ),
  })
  .required();
